type WipSettings = {
  key: string;
  endpoint: string;
};

export const WIP_SETTINGS: WipSettings[] = [
  {
    key: 'default',
    endpoint: 'tables/V_PARAMETER_LIST',
  },
  {
    key: 'values',
    endpoint: 'tables/V_PARAMETER_VALUES', 
  }
];